export type TrackpadGestureMode = 'off' | 'smart' | 'trackpad';

/** Unknown/old boolean values must never opt users into experimental input. */
export const trackpadGestureMode = (value: unknown): TrackpadGestureMode =>
  value === 'smart' || value === 'trackpad' ? value : 'off';
